import { DateObject, type TransactionSummaryDTO } from '@capsicum/common';

import { formatShortDate } from './formatShortDate';

export type TransactionsGroupedByDay = { [formattedDate: string]: Array<TransactionSummaryDTO> };

export const groupTransactionsByDay = (data: Array<TransactionSummaryDTO> | undefined): TransactionsGroupedByDay => {
	if (!data) {
		return {};
	}

	const currentYear = new DateObject().getFullYear();

	return [...data]
		.sort((a: TransactionSummaryDTO, b: TransactionSummaryDTO) => {
			const dateA = new DateObject(a.date ?? 0).getTime();
			const dateB = new DateObject(b.date ?? 0).getTime();

			return dateB - dateA;
		})
		.reduce((acc, transaction) => {
			const date = transaction.date ? formatShortDate(transaction.date, currentYear) : 'unknown';

			acc[date] = acc[date] || [];
			acc[date]?.push(transaction);

			return acc;
		}, {} as TransactionsGroupedByDay);
};
